import {
  VlocPaymentSchedule,
  VlocPaymentScheduleV2,
} from '@varo/graphql-schema-types';
import { createSessionMemoryStore } from 'shared/utils/sessionMemoryStore/sessionMemoryStore';

type PaymentSchedule = VlocPaymentSchedule | VlocPaymentScheduleV2;

const paymentScheduleStore = createSessionMemoryStore<PaymentSchedule[]>();

export const storePaymentSchedule = paymentScheduleStore.store;

export const getPaymentSchedule = (paymentScheduleId?: string) =>
  paymentScheduleStore.get(paymentScheduleId);

export const removePaymentSchedule = paymentScheduleStore.remove;
